import { ProductListItemFragment } from "@graphcommerce/magento-product";
import { ProductWishlistChip } from "@graphcommerce/magento-wishlist";
import Link from "next/link";
import { AddToCompareBtn } from "../Product/AddToCompareBtn";
import ProductAddToWishlistBtn from "../Product/ProductAddToWishlistBtn";
import Ratings from "../Product/Rating";
import IconStatsChartSharp from "../icons/IconStatsChartSharp";

export default function BottomAction(props: ProductListItemFragment & { id: number }) {

  return (
    <span className="relative  w-full  flex flex-row justify-start items-center align-middle  ">
      {/* <Ratings color="text-light-400" rating={(props.rating_summary / 100) * 5} /> */}


      {/*  <IconHeart width={18} height={18} className="text-white" /> */}
      <ProductAddToWishlistBtn {...props} color="text-light-200" size={22} />

      <AddToCompareBtn
        product_image_url={props?.small_image?.url!}
        product_name={props?.name!}
      />

    </span>
  )
}